import { fetchAuthSession } from 'aws-amplify/auth';
import { ApiErrorResult } from '@@/types/ApiResult';
import { StorageHelper } from '@@/lib/StorageHelper';
import { config } from '@@/configuration/env-config';

/**
 * @deprecated ApiClientBase will soon be deprecated.
 * [ApiClientBaseV2](./api-v2.ts) should be used in its place.
 */
export abstract class ApiClientBase {
  protected getApiUrl(url: string) {
    let apiEndpoint = config.api;
    if (apiEndpoint?.endsWith('/')) {
      apiEndpoint = apiEndpoint.slice(0, -1);
    }
    return `${apiEndpoint}/v1${url}`;
  }

  protected getAcgrApiUrl(url: string) {
    let apiEndpoint = config.acgrApi;

    if (apiEndpoint?.endsWith('/')) {
      apiEndpoint = apiEndpoint.slice(0, -1);
    }

    return `${apiEndpoint}${url}`;
  }

  protected getQicApiUrl(url: string) {
    let apiEndpoint = config.qicApi;
    if (apiEndpoint?.endsWith('/')) {
      apiEndpoint = apiEndpoint.slice(0, -1);
    }
    return `${apiEndpoint}${url}`;
  }
  protected getCenteneApiUrl(url: string) {
    let apiEndpoint = config.centeneApi;

    if (apiEndpoint?.endsWith('/')) {
      apiEndpoint = apiEndpoint.slice(0, -1);
    }
    return `${apiEndpoint}${url}`;
  }

  protected getPbrApiUrl(url: string) {
    let apiEndpoint = config.pbrApi;
    if (apiEndpoint?.endsWith('/')) {
      apiEndpoint = apiEndpoint.slice(0, -1);
    }
    return `${apiEndpoint}${url}`;
  }

  protected getCommonApiUrl(url: string) {
    let apiEndpoint = config.commonApi;
    if (apiEndpoint?.endsWith('/')) {
      apiEndpoint = apiEndpoint.slice(0, -1);
    }
    return `${apiEndpoint}${url}`;
  }

  protected getBulkEditApiUrl(url: string) {
    let apiEndpoint = config.bulkEditApi;
    if (apiEndpoint?.endsWith('/')) {
      apiEndpoint = apiEndpoint.slice(0, -1);
    }
    return `${apiEndpoint}${url}`;
  }

  protected getFreshdeskApiUrl(url: string) {
    let apiEndpoint = config.freshdeskApi;
    if (apiEndpoint?.endsWith('/')) {
      apiEndpoint = apiEndpoint.slice(0, -1);
    }
    return `${apiEndpoint}${url}`;
  }

  protected getCasesApiUrl(url: string) {
    if (!config.casesApi) {
      throw new Error('casesApi is not configured');
    }
    let apiEndpoint = config.casesApi;
    if (apiEndpoint.endsWith('/')) {
      apiEndpoint = apiEndpoint.slice(0, -1);
    }
    const cleanUrl = url.startsWith('/') ? url.substring(1) : url;
    return `${apiEndpoint}/${cleanUrl}`;
  }

  protected getMockApiUrl(url: string) {
    let apiEndpoint = 'https://ad05bd2d-080c-4fc7-8bc6-2d7ad4d16bbe.mock.pstmn.io';
    if (apiEndpoint.endsWith('/')) {
      apiEndpoint = apiEndpoint.slice(0, -1);
    }

    return `${apiEndpoint}/v1${url}`;
  }

  protected getReportingApiUrl(url: string) {
    let apiEndpoint = config.reportingApi || 'https://366noi599j.execute-api.us-west-2.amazonaws.com/dev';
    if (apiEndpoint.endsWith('/')) {
      apiEndpoint = apiEndpoint.slice(0, -1);
    }

    return `${apiEndpoint}${url}`;
  }

  protected getInsightsApiUrl(url: string) {
    let apiEndpoint = config.insightsApi + 'insights';

    if (apiEndpoint?.endsWith('/')) {
      apiEndpoint = apiEndpoint.slice(0, -1);
    }
    return `${apiEndpoint}${url}`;
  }

  protected getDfcApiUrl(url: string) {
    let apiEndpoint = config.dfcApi;

    if (apiEndpoint?.endsWith('/')) {
      apiEndpoint = apiEndpoint.slice(0, -1);
    }
    return `${apiEndpoint}${url}`;
  }

  protected getGraclApiUrl(url: string) {
    let apiEndpoint = config.graclApi;
    if (apiEndpoint?.endsWith('/')) {
      apiEndpoint = apiEndpoint.slice(0, -1);
    }
    return `${apiEndpoint}${url}`;
  }

  protected getOutageNotificationsApiUrl(url: string, baseUrlOverride?: string) {
    let apiEndpoint = baseUrlOverride ?? config.outageNotificationsApi;
    if (apiEndpoint?.endsWith('/')) {
      apiEndpoint = apiEndpoint.slice(0, -1);
    }
    return `${apiEndpoint}/outage-notifications${url}`;
  }

  protected getKnowledgeManagementApiUrl(url: string) {
    let apiEndpoint = config.knowledgeManagementApi;
    if (apiEndpoint?.endsWith('/')) {
      apiEndpoint = apiEndpoint.slice(0, -1);
    }
    return `${apiEndpoint}${url}`;
  }

  protected async getHeaders() {
    const companyId = StorageHelper.getCompanyId() || 'pronetx';
    return {
      Authorization: `Bearer ${await this.getIdToken()}`,
      'company-id': companyId,
      'content-type': 'application/json'
    };
  }

  protected async getIdToken() {
    const session = await fetchAuthSession();
    return session.tokens?.idToken?.toString();
  }

  protected error(message: string, errorCode?: string): ApiErrorResult {
    console.error(message);
    return {
      ok: false,
      message,
      ...(errorCode && { errorCode })
    };
  }

  protected formatQueryStrings(requestBody: object) {
    const queryParams = new URLSearchParams();

    Object.entries(requestBody).forEach(([key, value]) => {
      if (value !== undefined && value !== '') {
        queryParams.append(key, value);
      }
    });

    return queryParams.toString();
  }
}
